import type { SVGProps } from "react";

export function SneakerIcon({
  size = 20,
  strokeWidth = 1.75,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number | string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d="M3 17h18" />
      <path d="M3 14.5c0-1.4 1.1-2.5 2.5-2.5h2.6l2-3.6c.3-.6 1-1 1.7-1h1.8c.6 0 1.2.3 1.6.7l2.4 2.7c.3.4.8.6 1.3.6h1.6c.8 0 1.5.7 1.5 1.5V16c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1v-1.5z" />
      <path d="M8.5 12l1 2.2M11 11l1 2.4M13.5 11l1 2.4" />
    </svg>
  );
}
